var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 200,
    viewBox: "0 0 180 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 150.5L146.5 80L132.5 66L76 122.5L47.5 94L33.5 108L76 150.5ZM20 200C14.5 200 9.79167 198.042 5.875 194.125C1.95833 190.208 0 185.5 0 180V40C0 34.5 1.95833 29.7917 5.875 25.875C9.79167 21.9583 14.5 20 20 20H62C64.1667 14 67.7917 9.16667 72.875 5.5C77.9583 1.83333 83.6667 0 90 0C96.3333 0 102.042 1.83333 107.125 5.5C112.208 9.16667 115.833 14 118 20H160C165.5 20 170.208 21.9583 174.125 25.875C178.042 29.7917 180 34.5 180 40V180C180 185.5 178.042 190.208 174.125 194.125C170.208 198.042 165.5 200 160 200H20ZM20 180H160V40H20V180ZM90 32.5C92.1667 32.5 93.9583 31.7917 95.375 30.375C96.7917 28.9583 97.5 27.1667 97.5 25C97.5 22.8333 96.7917 21.0417 95.375 19.625C93.9583 18.2083 92.1667 17.5 90 17.5C87.8333 17.5 86.0417 18.2083 84.625 19.625C83.2083 21.0417 82.5 22.8333 82.5 25C82.5 27.1667 83.2083 28.9583 84.625 30.375C86.0417 31.7917 87.8333 32.5 90 32.5Z",
    fill: "#169c50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/Selected.a30ffd416c8d71fe3887e9719bfdc682.svg";
export { ForwardRef as ReactComponent };